import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OpenGraphService} from "../open-graph.service";
import {OpenGraphData, OpenGraphImageInfo} from "../model/OpenGraphData";

@Component({
  selector: 'app-link-preview',
  templateUrl: './link-preview.component.html',
  styleUrls: ['./link-preview.component.scss']
})
export class LinkPreviewComponent implements OnInit {
  @Input() link?: string | null;
  @Input() openGraphData?: OpenGraphData;
  @Input() removable: boolean = true;
  @Output() onLoad = new EventEmitter();
  @Output() onDelete = new EventEmitter();

  _hidden: boolean = false;

  constructor(
    private openGraphService: OpenGraphService
  ) { }

  ngOnInit() {
    if (this.link && this.openGraphService.isLink(this.link)) {
      this.loadPreview();
    } else if(this.openGraphData) {
      this.loadImageInfo();
    } else{
      this.setHidden(true);
    }
  }

  isPreview(): boolean {
    return !this.isHidden() && (!!this.link || !!this.openGraphData);
  }

  setData(data: OpenGraphData) {
    if (!data || !data.title) {
      return;
    }
    this.openGraphData = data;
    this.loadImageInfo();
    this.setHidden(false);
  }

  getData() {
    return this.openGraphData;
  }

  setLink(link: string) {
    if (this.link === link) {
      return;
    }
    this.link = link;
    this.loadPreview();
  }

  removePreView() {
    this.onDelete.emit(this);
    this.clearData();
  }

  getDomain(url?: string): string {
    if (!url) {
      return '';
    }
    let domain = url.split('/')[2] || '';
    return domain.replace('www.', '');
  }

  clearData() {
    this.link = null;
    this.openGraphData = undefined;
    this.setHidden(true);
  }

  private loadPreview() {
    this.setHidden(false);
    if (this.link && this.openGraphService.isLink(this.link)) {
      this.openGraphService.loadPreviewLink(this.link, (data: OpenGraphData) => {
        if (data) {
          this.setData(data);
        } else {
          this.setHidden(true);
        }
      });
    } else {
      this.setHidden(true);
    }
  }

  private loadImageInfo() {
    if (this.openGraphData && this.openGraphData.image) {
      this.openGraphService.loadImageInfo(this.openGraphData.image, (imageInfo: OpenGraphImageInfo) => {
        if(this.openGraphData) {
          this.openGraphData.imageInfo = imageInfo;
        }
      });
    }
  }

  private setHidden(hidden: boolean) {
    this._hidden = hidden;
  }

  private isHidden() {
    return this._hidden;
  }
}
